<template lang="pug">
.usuarios.container.grid-lg.py-2
  .usuario
    load-manager(:status="status")
      .card(v-if="current")
        .card-header
          .card-title
            b {{ current.login | cpfCnpj }}
            span &nbsp;{{ current.nome }}
            .pb-2 {{ current.email }}
        .card-body
          .columns
            item-col.col-4.col-xs-6.py-1(
              label="usuario.validado_por",
              :value="current | enums('usuario.validado_por')",
              :class="{ danger: 'nenhum' == current.validado_por }"
            )
            item-col.col-4.col-xs-6.py-1(
              label="usuario.matricula",
              :value="current.matricula || '-'"
            )
            item-col.col-4.col-xs-6.py-1(
              label="usuario.codigo_fiscal",
              :value="current.codigo_fiscal || '-'"
            )
            item-col.col-4.col-xs-6.py-1(
              label="usuario.dados_atualizado_em",
              :value="current.dados_atualizado_em | date"
            )
            item-col.col-4.col-xs-6.py-1(
              label="usuario.recebe_os",
              :value="current.recebe_os ? 'Sim' : 'Não'"
            )
            item-col.col-4.col-xs-6.py-1(
              label="usuario.fiscal",
              :value="current.fiscal ? 'Sim' : 'Não'"
            )
            item-col.col-4.col-xs-6.py-1(
              label="usuario.cargo",
              :value="current.cargo ? current.cargo.descricao : ''"
            )
            item-col.col-4.col-xs-6.py-1(
              label="usuario.data_admissao",
              :value="current.data_admissao | date"
            )
            .column.col-12(v-if="current.perfis")
              .divider
              .item-col
                .abbr {{ "usuario.perfis" | tModel }}
                .columns
                  .column.item-col.col-4.col-xs-6(v-for="p in current.perfis") {{ p.descricao }}
          .column.col-12(v-if="current.pessoa && current.pessoa.modulos")
            .abbr {{ "pessoa.modulos" | tModel }}
            .modulos
              .label.label-primary.label-rounded(
                v-for="m in current.pessoa.modulos"
              ) {{ m.titulo }}
          div(v-if="current.pessoa")
            .divider
            .b.abbr Pessoa do usuário
            .columns
              item-col.col-6(
                label="pessoa.cpf_cnpj",
                :value="current.pessoa.cpf_cnpj | cpfCnpj"
              )
              item-col.col-6(
                label="pessoa.razao_social",
                :value="current.pessoa.razao_social"
              )
              item-col.col-6(
                label="pessoa.nome_fantasia",
                :value="current.pessoa.nome_fantasia"
              )
              item-col.col-6(
                label="pessoa.inscricao_estadual",
                :value="current.pessoa.inscricao_estadual"
              )
              item-col.col-6(
                label="pessoa.email",
                :value="current.pessoa.email"
              )
              item-col.col-6(
                label="pessoa.fone",
                :value="current.pessoa.fone | phone"
              )
              item-col.col-6(
                label="pessoa.celular",
                :value="current.pessoa.celular | phone"
              )
              item-col.col-6(label="pessoa.site", :value="current.pessoa.site")
              item-col.col-6(label="pessoa.rg", :value="current.pessoa.rg")
              item-col.col-6(
                label="pessoa.rg_orgao_emissor",
                :value="current.pessoa.rg_orgao_emissor"
              )
              item-col.col-6(
                label="pessoa.rg_emissao",
                :value="current.pessoa.rg_emissao | date('DD/MM/YYYY')"
              )
              item-col.col-6(
                label="pessoa.rg_uf",
                :value="current.pessoa.rg_uf"
              )
              item-col.col-6(label="pessoa.crc", :value="current.pessoa.crc")
              item-col.col-12(
                label="pessoa.endereco",
                :value="current.pessoa.endereco_formatado"
              )
          .comentarios
            .divider
            .b.abbr Comentários
            div(v-if="current.comentarios && current.comentarios.length")
              .comentario(v-for="comentario in current.comentarios")
                .abbr
                  span {{ comentario.realizado_em | date }} -
                  span(v-if="comentario.usuario") {{ comentario.usuario.nome }}
                .small.text-long {{ comentario.descricao }}
          .validacao_contas
            .divider
            .b.abbr Validação conta
            div(
              v-if="current.validacao_contas && current.validacao_contas.length"
            )
              .validacao_conta(v-for="conta in current.validacao_contas")
                .columns
                  item-col.col-4(
                    label="validacao_conta.created_at",
                    :value="conta.created_at | date"
                  )
                  item-col.col-4(
                    label="validacao_conta.updated_at",
                    :value="conta.updated_at | date"
                  )
                  item-col.col-4.text-right(
                    label="validacao_conta.situacao",
                    :value="conta | enums('validacao_conta.situacao')"
                  )
                .pt-2.documentos.columns(
                  v-if="conta.documentos && conta.documentos.length"
                )
                  .documento.column.col-6.col-xs-12(
                    v-for="doc in conta.documentos"
                  )
                    .card
                      .card-header
                        .cart-title.h5 {{ doc | enums("validacao_conta_doc.tipo") }}
                      .card-body
                        div(v-if="doc.urls && doc.urls.length")
                          viewer(
                            :images="doc.urls",
                            :options="{ title: false, scalable: false }"
                          )
                            img.img-fit-cover.p-1.img-doc.c-hand(
                              v-for="url in doc.urls",
                              :src="url",
                              :key="url"
                            )
                        div(v-if="doc.comentarios && doc.comentarios.length")
                          div(v-for="comentario in doc.comentarios")
                            .abbr
                              span {{ comentario.created_at | date }} -
                              span(v-if="comentario.usuario") {{ comentario.usuario.nome }}
                            .small.text-long {{ comentario.descricao }}
          div
            .divider
            .h5 Dados de Acessos Externo
            div(v-if="current.externos && current.externos.length > 0")
              .py-2(v-for="(externo, i) in current.externos")
                .divider(v-if="i > 0")
                div
                  img(
                    :alt="externo.origem",
                    :src="`${authURL}/assets/images/${externo.origem}.png`",
                    style="height: 20px; vertical-align: middle"
                  )
                  span &nbsp; {{ externo | enums("usuario_externo.origem") }}
                .columns.py-2
                  item-col.col-6.col-md-12(
                    label="Login",
                    :value="externo.dados.login"
                  )
                  item-col.col-6.col-md-12(
                    label="Nome",
                    :value="externo.dados.nome"
                  )
                  .column.col-6
                    .item-col
                      .abbr E-mail
                      .small {{ externo.dados.email || "-" }}
                      .text-success.text-small(
                        v-if="externo.dados.email_verificado"
                      )
                        i.fa.fa-certificate
                        | &nbsp;Verificado
                  .column.col-6
                    .item-col
                      .abbr Fone
                      .small {{ externo.dados.fone | phone }}
                      .text-success.text-small(
                        v-if="externo.dados.fone_verificado"
                      )
                        i.fa.fa-certificate
                        | &nbsp;Verificado
                  .column.col-12.pt-2(
                    v-if="externo.dados.govbr_niveis && externo.dados.govbr_niveis.length"
                  )
                    .abbr Níveis
                    .tile.tile-centered.mb-2(
                      v-for="nivel in externo.dados.govbr_niveis"
                    )
                      .tile-icon
                        span.fa-stack.centered
                          i.fa.fa-circle.fa-stack-2x(
                            :class="`gov-br-nivel-${nivel.id}`"
                          )
                          i.fa.fa-stack-1x.fa-inverse(
                            :class="nivelClass(nivel.id)"
                          )
                      .tile-content
                        div {{ nivel.id }}: {{ nivel.descricao }}
                        .abbr em: {{ new Date(nivel.dataAtualizacao) | date }}
                  .column.col-12.pt-2(
                    v-if="externo.dados.govbr_selos && externo.dados.govbr_selos.length"
                  )
                    .abbr Selos
                    .tile.tile-centered.mb-2(
                      v-for="selo in externo.dados.govbr_selos"
                    )
                      .tile-icon
                        span.fa-stack.centered
                          i.fa.fa.fa-star.fa-lg
                      .tile-content
                        div {{ selo.id }}: {{ selo.descricao }}
                        .abbr em: {{ new Date(selo.dataAtualizacao) | date }}

        .card-footer.text-right
          router-link.btn.btn-link(
            :to="{ name: 'app.sistema.usuarios.afastamentos', params: { id: current.id } }",
            v-acl:allowed.admin.produtividade.afastamentos.create,
            :disabled="!current.cargo"
          )
            btn-content(icon="fa fa-stop-circle-o", label="Afastamentos")
          btn-logs(
            entityName="Usuario",
            :entityId="current.id",
            v-acl:allowed.admin.logs.index
          )
          router-link.warning.btn.btn-link(
            :to="{ name: 'app.sistema.usuarios.edit', params: { id: current.id } }",
            v-acl:allowed.admin.sistema.usuarios.update
          )
            btn-content(name="edit")
</template>

<script>
import envs from "@/config/envs"
import "viewerjs/dist/viewer.css"
import Viewer from "v-viewer"
import Vue from "vue"
Vue.use(Viewer)

export default {
  vuex: {
    "sistema/usuarios": {
      state: ["current", "status"],
      actions: ["fetchOne"],
    },
  },

  computed: {
    usuarioId() {
      return Number(this.$route.params.id)
    },
    authURL() {
      return envs.authURL
    },
  },

  methods: {
    isFetchOne() {
      return !this.current || Number(this.current.id) !== this.usuarioId
    },
    nivelClass(id) {
      if ("1" === id) return "fa-star-o"
      if ("2" === id) return "fa-star-half-o"
      if ("3" === id) return "fa-star"
      return "fa-star"
    },
  },

  mounted() {
    if (this.isFetchOne()) {
      this.fetchOne(this.usuarioId)
    }
  },
}
</script>

<style src="./usuarios.styl" lang="stylus"></style>
